import { Table } from 'dexie';
import db, { Database } from '@/db';
import DBMetadataModel from '../models/DBMetadataModel';
import { DBMetadataKey, dbMetadataExpiration } from '../helpers/dbMetadata';

export type TABLE_TYPE = Table<DBMetadataModel>;

export const TABLE = 'dbMetadata';
const SCHEMA = 'key';

class DBMetadataDatabase {
  constructor(private db: Database) {
    db.registerModelSchema(TABLE, SCHEMA);
  }

  async getLastUpdatedAt(key: DBMetadataKey): Promise<string | undefined> {
    const record = await this.db[TABLE].get(key);
    return record?.lastUpdatedAt;
  }

  async getAll(): Promise<Record<string, string>> {
    const records = await this.db[TABLE].toArray();
    return records.reduce(
      (acc, record) => {
        acc[record.key] = record.lastUpdatedAt;
        return acc;
      },
      {} as Record<string, string>,
    );
  }

  setLastUpdatedAt(key: DBMetadataKey, timestamp: string): Promise<void> {
    return this.db[TABLE].put({ key, lastUpdatedAt: timestamp });
  }

  async isStale(key: DBMetadataKey): Promise<boolean> {
    const lastUpdated = await this.getLastUpdatedAt(key);
    if (!lastUpdated) return true;

    const expiry = dbMetadataExpiration[key];
    const age = Date.now() - new Date(lastUpdated).getTime();
    return age > expiry;
  }

  async updateNow(key: DBMetadataKey): Promise<void> {
    const now = new Date().toISOString();
    await this.setLastUpdatedAt(key, now);
  }
}

export const DBMetadataDB = new DBMetadataDatabase(db);
